
import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate';
import convertImageTemplateFields from './lib/convertImageTemplateFields'
import useFlowTranslate from 'FlowBuilder/hooks/useFlowTranslate'
import { deepSnakeCase } from 'Shared/functions/util';

export default function useRenderContext({ actionId }) {
  const flow = useSel(s => (s.taker || s.builder).flow)
  const action = useSel(s => (s.taker || s.builder).flow.actions.find(a => a.id === actionId)) || {}
  const isEmbed = useSel(s => !!s.local?.isEmbed)
  const templateFields = flow.template.fields || []

  const templateFieldDefaults = _.mapValues(_.keyBy(_.filter(templateFields, 'defaultValue'), 'slug'), 'defaultValue')
  const templateFieldsValues = flow.templateFields
  const { fallback: actionTranslatedValues } = useActionTranslate({ actionId: action.id })
  const { fallback: flowTranslatedValues } = useFlowTranslate()
  const translatedValues = _.merge({}, flowTranslatedValues, actionTranslatedValues)
  const noNullTranslatedValues = _.omitBy(translatedValues, (v) => typeof v === 'undefined')

  const transformedTemplateFields = convertImageTemplateFields(templateFields, { ...templateFieldDefaults, ...templateFieldsValues, ...deepSnakeCase(noNullTranslatedValues) })

  const flowFields = { ...flow.flowFields, current_action_kind: action?.kind, is_embedded: isEmbed } // snake because passed to Liquid

  return {
    template: transformedTemplateFields,
    settings: Object.fromEntries(Object.entries(flow.settings).map(([k, v]) => [_.snakeCase(k), v])),
    flow: flowFields,
    client: {
      brand: window.ENV.CLIENT_BRAND
    }
  }
}
